import classNames from "classnames";
import AscImage from "../AscImage/AscImage";
import styles from "./AscEmojiRating.module.scss";
import ConcernedEmoji from "../../assets/images/emoji_concerned.webp";
import SadEmoji from "../../assets/images/emoji_sad.webp";
import NoEmotionEmoji from "../../assets/images/emoji_no_emotion.webp";
import HappyEmoji from "../../assets/images/emoji_happy.webp";
import LoveEyesEmoji from "../../assets/images/emoji_love_eyes.webp";
import { useState } from "react";
export interface AscEmojiRatingProps {
  className?: string;
  onChange?: (value: number) => void;
}

const ratings = [
  {
    value: 1,
    emoji: ConcernedEmoji,
  },
  {
    value: 2,
    emoji: SadEmoji,
  },
  {
    value: 3,
    emoji: NoEmotionEmoji,
  },
  {
    value: 4,
    emoji: HappyEmoji,
  },
  {
    value: 5,
    emoji: LoveEyesEmoji,
  },
];
export default function AscEmojiRating({
  className,
  onChange,
}: AscEmojiRatingProps) {
  const [rating, setRating] = useState<number | null>(null);

  function handleRatingChange(value: number) {
    setRating(value);
    onChange?.(value);
  }
  return (
    <div
      data-testid="asc-emoji-rating"
      className={classNames(styles.ground, className)}
    >
      {ratings?.map(({ value, emoji }) => (
        <AscImage
          onClick={() => handleRatingChange(value)}
          className={classNames(styles.emoji, {
            [styles.inactive]: rating !== null && rating !== value,
          })}
          data-testid={`asc-emoji-rating-emoji-${value}`}
          src={emoji}
          key={value}
        />
      ))}
    </div>
  );
}
